module.exports = __webpack_public_path__ + "static/media/text.eb7ecc9c.svg";